import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES, HOTEL, inr } from "@/constants/hotelData";
import Reveal from "@/components/Reveal";

export default function About() {
  return (
    <section id="story" className="relative py-24 sm:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-10">
        <Reveal className="relative lg:col-span-6">
          <div className="relative">
            <img
              src={IMAGES.story}
              alt="Hotel Raj architecture in the evening"
              className="aspect-[4/3] w-full rounded-2xl object-cover"
              data-testid="about-main-image"
            />
            <img
              src={IMAGES.storySmall}
              alt="Warmly lit guest room"
              className="absolute -bottom-10 -right-3 hidden w-44 rounded-xl border border-gold/30 object-cover shadow-[0_20px_60px_rgba(0,0,0,0.6)] sm:block sm:w-56"
              data-testid="about-small-image"
            />
            <div className="glass absolute -left-3 -top-5 rounded-xl px-5 py-4 sm:-left-6">
              <div className="font-serif text-3xl text-gold">{HOTEL.totalRooms}</div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-cream/70">Rooms of Comfort</div>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-6 lg:pl-8">
          <Reveal delay={0.1}>
            <p className="mb-4 text-[10px] font-medium uppercase tracking-[0.34em] text-gold sm:text-xs">
              Our Story
            </p>
            <h2 className="font-serif text-3xl leading-snug tracking-tight text-cream sm:text-4xl lg:text-[2.75rem]">
              Where Champaran's warmth meets <span className="gold-gradient-text italic">royalty</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base font-light leading-relaxed text-stone-300">
              Set on Ghorasahan Road near the Overbridge at Dhaka, Hotel Raj
              brings a calm, royal ease to East Champaran. Behind our doors
              await twenty well-kept rooms, warm lamps and slow, restful
              mornings — for the traveller who values rest as much as the road.
            </p>
            <p className="mt-4 text-base font-light leading-relaxed text-stone-300">
              Every stay carries the same promise: honest hospitality, spotless
              comfort and a table that always has room for one more.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-8 flex flex-wrap gap-8 border-t border-gold/15 pt-8">
              <div>
                <div className="font-serif text-2xl text-gold">{HOTEL.totalRooms}</div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-cream/60">Rooms</div>
              </div>
              <div>
                <div className="font-serif text-2xl text-gold">{inr(HOTEL.ratePerNight)}</div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-cream/60">Per Night</div>
              </div>
              <div>
                <div className="font-serif text-2xl text-gold">24×7</div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-cream/60">Room Service</div>
              </div>
            </div>
            <Link
              to="/book"
              data-testid="about-book-link"
              className="mt-9 inline-flex items-center gap-2 border-b border-gold/50 pb-1 text-xs font-semibold uppercase tracking-[0.24em] text-gold transition-colors hover:border-gold hover:text-goldlight"
            >
              Book Your Stay <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
